<template>
    <path
        d="m6 18 6-6m0 0 6-6m-6 6L6 6m6 6 6 6"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
    />
</template>

<script>
import IconSvgBase from "./IconSvgBase";

export default {
    extends: IconSvgBase,
    name: "IconClose",
};
</script>
